// extracted by mini-css-extract-plugin
module.exports = {"container":"EditPastActivitiesApp--container--yveWs"};